import { NotificationService } from './../../../shared/notification/notification.service';
import { MultiInvoicePaymentComponent } from './../../multi-invoice-payment/multi-invoice-payment.component';
import { UnappliedPaymentSearchDto } from './../../shared/unapplied-payment/dto/unapplied-payment-search.dto';
import { UnappliedPaymentService } from './../../shared/unapplied-payment/unapplied-payment.service';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'wl-apply-unapplied-payments-dialog',
  templateUrl: './apply-unapplied-payments-dialog.component.html',
  styleUrls: ['./apply-unapplied-payments-dialog.component.less'],
    standalone: false
})
export class ApplyUnappliedPaymentsDialogComponent implements OnInit, OnChanges {
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    if (value) {
      this.resetData();
    }
    this.showChange.emit(this._show);
  }
  @Input() invoiceNumbers: number[];
  @Input() profileId: number;
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Output() paymentsApplied: EventEmitter<boolean> = new EventEmitter();

  @ViewChild(MultiInvoicePaymentComponent) _multiInvoicePaymentComponent: MultiInvoicePaymentComponent;

  isSaving: boolean;
  loading: boolean;
  unappliedPaymentsBalance = 0;

  private _show: boolean;

  constructor(
    private _unappliedPaymentService: UnappliedPaymentService,
    private _notificationService: NotificationService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileId && this.profileId) {
      this.search();
    }
  }

  search() {
    if (this.profileId) {
      this.loading = true;
      const params = {
        ProfileId: this.profileId,
        PageSize: 0,
      } as UnappliedPaymentSearchDto;
      this._unappliedPaymentService.search(params).then(result => {
        this.unappliedPaymentsBalance = result.TotalBalance;
        this.loading = false;
      });
    }
  }

  resetData() {
    this.search();
    this._multiInvoicePaymentComponent.resetData();
  }

  saveClicked() {
    this.isSaving = true;
    this._multiInvoicePaymentComponent.applyPayments().then(
      result => {
        this.isSaving = false;
        this._notificationService.success(...result.messages);
        this.paymentsApplied.emit(true);
        this.show = false;
      },
      errorResult => {
        this.isSaving = false;
        if (errorResult.messages) {
          this._notificationService.error(...errorResult.messages);
        }
      }
    );
  }
}
